import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  proposalCode: "",
  clientLogo: null,
  backgroundImage: null,
  portraitBackgroundImage: null,
  portraitInnerBackgroundImage: null,
  innerBackgroundImage: null,
  homepageCollaterals: [],
  homepageCollateralShape: null,
  quotationText: null,
  pillars: [],
  marketChallenges: '',
  marketDrivers: '',
  marketTrend: '',
  competitors: '',
  industryDynamicCards: [],
  helpSectionCards: [],
  prioritiesCards: [],
  selectCredentials: [],
  scheduleCallURL: "",
  strategicPriorities: null,
  theme: "default",
  marketingAccordion: [],
  header: {},
  activeInternalPage: 0,
  sPocEmail: '',
  overallIndustryDynamics: null,
  backgroundImages: {
    backgroundImage: null,
    innerBackgroundImage: null,
    portraitBackgroundImage: null,
    portraitInnerBackgroundImage: null,
  }
}

export const sliceName = "pitchDeckSlice"
export const pitchDeckSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setPitchDeckData: (state, action) => {
      const pitchDeckData = action.payload;
      let count = 0
      if (action.payload.marketDrivers || action.payload.marketTrend || action.payload.marketChallenges || action.payload.competitors || action.payload.overallIndustryDynamics) {
        pitchDeckData['cardWithOrder'] = {
          ...pitchDeckData['cardWithOrder'],
          [count]: action.payload.industryDynamicCards
        }
        count++
      }
      if (action.payload.strategicPriorities) {
        pitchDeckData['cardWithOrder'] = {
          ...pitchDeckData['cardWithOrder'],
          [count]: action.payload.prioritiesCards
        }
        count++
      }
      if (action.payload.marketingAccordion) {
        pitchDeckData['cardWithOrder'] = {
          ...pitchDeckData['cardWithOrder'],
          [count]: action.payload.helpSectionCards
        }
        count++
      }
      // if (action.payload.pitchDeckCredentials || action.payload.pitchDeckCredentialsHeader || action.payload.relatedArticles || action.payload.relatedArticlesHeader) {
      //   pitchDeckData['cardWithOrder'][count] = <SelectCredentials />
      //   count++
      // }
      // pitchDeckData['cardWithOrder'] = {
      //   0: action.payload.industryDynamicCards,
      //   1: action.payload.prioritiesCards,
      //   2: action.payload.helpSectionCards,
      // }
      pitchDeckData['backgroundImages'] = {
        backgroundImage: action.payload.backgroundImage,
        innerBackgroundImage: action.payload.innerBackgroundImage,
        portraitBackgroundImage: action.payload.portraitBackgroundImage,
        portraitInnerBackgroundImage: action.payload.portraitInnerBackgroundImage,
      }

      if(pitchDeckData["marketingAccordionView"] === null){
          pitchDeckData["marketAccordionType"] = "accordion"  
        }else{
          pitchDeckData["marketAccordionType"] = pitchDeckData["marketingAccordionView"]  
      }

      return pitchDeckData;
    },
    setActiveInternalPage: (state, action) => {
      state.activeInternalPage = action.payload
    }
  }
})


export const pitchDeckDataState = state => state[sliceName]
export const pitchDeckHeaders = state => state[sliceName].header
export const pitchDeckActiveInternalPage = state => state[sliceName].activeInternalPage
export const cardWithOrder = state => state[sliceName].cardWithOrder


export const selectMarketDrivers = state => state[sliceName].marketDrivers
export const selectClientLogo = state => state[sliceName].clientLogo
export const selectMarketTrends = state => state[sliceName].marketTrend
export const selectMarketChallenges = state => state[sliceName].marketChallenges
export const selectCompetitors = state => state[sliceName].competitors
export const selectStrategicPriorities = state => state[sliceName].strategicPriorities
export const selectHomeQuote = state => state[sliceName].quotationText
export const SelectAccordionData = state => state[sliceName].marketingAccordion
export const selectPitchDeckCredentials = state => state[sliceName].pitchDeckCredentials
export const selectPitchDeckCredentialsHeader = state => state[sliceName].pitchDeckCredentialsHeader
export const selectRelatedArticles = state => state[sliceName].relatedArticles
export const selectRelatedArticlesHeader = state => state[sliceName].relatedArticlesHeader
export const selectPillars = state => state[sliceName].pillars
export const selectHomePageCollaterals = state => state[sliceName].homepageCollaterals
export const selectHomePageCollateralShape = state => state[sliceName].homepageCollateralShape
export const scheduleCallURL = state => state[sliceName].scheduleCallURL
export const activeTheme = state => state[sliceName].theme
export const activeBackgroundImage = state => state[sliceName].backgroundImage
export const activeInnerBackgroundImage = state => state[sliceName].innerBackgroundImage
export const activePortraitBackgroundImage = state => state[sliceName].portraitBackgroundImage
export const activePortraitInnerBackgroundImage = state => state[sliceName].portraitInnerBackgroundImage
export const activeBackgroundImages = state => state[sliceName].backgroundImages
export const sPocEmail = state => state[sliceName].sPocEmail
export const selectOverallIndustryDynamics = state => state[sliceName].overallIndustryDynamics
export const selectMarketAccordionType = state => state[sliceName].marketAccordionType


export const { setPitchDeckData, setActiveInternalPage } = pitchDeckSlice.actions
export default pitchDeckSlice.reducer